import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AnalyticsNotesStructureTable = _resolveComponent("AnalyticsNotesStructureTable")!

  return (_openBlock(), _createBlock(_component_AnalyticsNotesStructureTable, {
    filter: _ctx.filter,
    isMonthly: _ctx.isMonthly,
    storePaths: _ctx.getStorePaths
  }, null, 8, ["filter", "isMonthly", "storePaths"]))
}